export default "__VITE_ASSET__c934285b__"